export const generateRandomName = () => {
  const adjectives = ['Happy', 'Sunny', 'Clever', 'Brave', 'Gentle', 'Wise', 'Kind', 'Swift', 'Bright', 'Cool'];
  const nouns = ['Panda', 'Tiger', 'Eagle', 'Dolphin', 'Fox', 'Wolf', 'Bear', 'Lion', 'Hawk', 'Owl'];
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  const randomNumber = Math.floor(Math.random() * 10000);
  return `${randomAdjective}${randomNoun}${randomNumber}`;
};
